var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/test1","tag":"button"}},[_vm._v("5656")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }